<template>
  <div class="brand">
    <banner :slides="BANNER_IMG" />
    <div class="news">
      <newsModal v-if="!$isMobile" :content="content" :show.sync="isContent" />
      <tab :data="tabs" v-model="type" @input="handleTabChange"></tab>
      <div v-if="news && news.length" class="news-list row">
        <div class="col-lg-4" v-for="item in news" :key="item.id">
          <div class="new" @click="handleClickNews(item)">
            <div class="image-container">
              <!-- class="img-fluid" -->
              <img :src="item.avatar" alt="item.title" />
            </div>
            <div class="text-warp">
              <div class="new-title">
                <p>{{ item.title }}</p>
                <span class="new-date">{{ item.created.split(" ")[0] }}</span>
              </div>
              <p class="new-desc" v-html="item.summary || item.content"></p>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="no-data">暂无数据</div>
    </div>
  </div>
</template>

<script>
import banner from "@/components/banner";
import tab from "@/components/tab";
import newsModal from "@/components/newsModal";

import BANNER_IMG from "../assets/images/banner/jslc4.png";

const tabs = [
  { label: "产品动态", value: "corporate" },
  // { label: "展览新闻", value: "exhibition" },
  // { label: "行业新闻", value: "industry" }
];

export default {
  name: "brand",
  components: {
    banner,
    tab,
    newsModal
  },
  data() {
    return {
      BANNER_IMG,
      tabs,
      type: "corporate",
      news: [],
      isContent: false,
      content: {},
      editor: null
    };
  },
  created() {
    this.getNews();
  },

  methods: {
    handleTabChange() {
      this.getNews();
      this.isContent = false;
    },
    getNews() {
      this.$api.brand
        .getBrandList({
          pageNo: 1,
          pageSize: 20,
          category: this.type
        })
        .then(res => {
          this.news = res.result.records;
        });
    },
    handleClickNews(news) {
      this.isContent = true;
      this.content = news;
      if (this.$isMobile) {
        this.$router.push("/news/" + news.id);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.brand {
  background: #f3f3f3;
}
.news {
  width: 72%;
  margin: 0 auto;
  padding: 30px;
  &-list {
    .new {
      margin: 30px 0;
      background: white;
      .text-warp {
        padding: 2rem 1rem 1rem;
        p {
          margin-bottom: 0;
          overflow: hidden;
          -o-text-overflow: ellipsis;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          height: 3rem;
          line-height: 1.5rem;
        }
      }
      .new-title {
        display: flex;
        font-size: 1.2rem;
        justify-content: space-between;
        align-items: baseline;
        flex-wrap: wrap;
        flex-direction: column;
        > p {
          margin-bottom: 0.5rem;
          height: 4rem;
          line-height: 2rem;
        }
      }
      &-date {
        font-size: 14px;
        color: #828282;
      }
      &:hover {
        cursor: pointer;
        box-shadow: 1px 6px 10px -4px;
      }
    }
  }
}
.image-container {
  width: 100%;
  height: 0;
  padding-bottom: 60%;
  overflow: hidden;
  img {
    width: 100%;
  }
}
.image-container::before {
  content: "";
  padding-top: 100%;
  float: left;
}
.image-container::after {
  content: "";
  display: block;
  clear: both;
}
.news-content {
  img {
    width: 100%;
  }
  &-title {
    text-align: center;
    margin: 2rem 0 1rem;
  }
  &-date {
    font-size: 14px;
    text-align: center;
    color: #bbb;
    margin-bottom: 2rem;
  }
  &-desc {
    padding: 1rem;
    background: #ececec;
    color: #707070;
  }
}
@include media-breakpoint-down(lg) {
  .news {
    padding: 2rem 1rem;
    margin: auto;
    width: 100%;
  }
}
</style>
